import $ from "jquery";

export function maxHeight() {
    let scrollHeight = window.innerHeight - 320;
    $(window).resize(function() {
        const h = window.innerHeight - 320;
        scrollHeight = h;
    });
    return scrollHeight
}
